import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Button,
  Input,
  Popconfirm,
  Table,
  Form,
  Select,
  InputNumber,
} from "antd";
import FetchSelect from "Components/fetch-select";
import React from "react";
import { Controller, useFieldArray } from "react-hook-form";
import { DISPLAY_MODE } from "Constants";

export default function HardwaresList({
  form,
  mode = DISPLAY_MODE.EDIT,
  ...props
}) {
  const { fields: hardwares, append, remove } = useFieldArray({
    control: form.control,
    name: "hardwares",
  });

  const errors = form.errors;

  const columns = [
    {
      title: "Donanım Markası",
      dataIndex: ["hardwares", "id"],
      editable: true,

      render: (text, record, index) => {
        return (
          <Form.Item
            style={{ margin: 0 }}
            hasFeedback={true}
            validateStatus={
              errors.hardwares &&
              errors.hardwares[index]?.hardwares?.id &&
              "error"
            }
          >
            <FetchSelect
              api="/masterdata/hardwaretypes"
              form={form}
              readOnly={mode === DISPLAY_MODE.READ_ONLY}
              defaultValue={record.hardwaretypes?.id}
              field={`hardwares[${index}].hardwareBrand`}
              placeholder="Donanım Markası"
            />
          </Form.Item>
        );
      },
    },

    {
      title: "Donanım Tipi",
      dataIndex: ["hardwares", "id"],
      editable: true,

      render: (text, record, index) => {
        return (
          <Form.Item
            style={{ margin: 0 }}
            hasFeedback={true}
            validateStatus={
              errors.hardwares &&
              errors.hardwares[index]?.hardwares?.id &&
              "error"
            }
          >
            <FetchSelect
              api="/masterdata/hardwaretype"
              form={form}
              defaultValue={record.hardwaretype?.id}
              field={`hardwares[${index}].hardwareType`}
              placeholder="Donanım Tipi"
              readOnly={mode === DISPLAY_MODE.READ_ONLY}
            />
          </Form.Item>
        );
      },
    },

    {
      title: "Adet",
      dataIndex: "piece",
      editable: true,

      render: (text, record, index) => {
        return (
          <Form.Item
            style={{ margin: 0 }}
            hasFeedback={true}
            validateStatus={
              errors.hardwares && errors.hardwares[index]?.piece && "error"
            }
          >
            <Controller
              control={form.control}
              name={`hardwares[${index}].piece`}
              as={
                <InputNumber
                  style={{ width: "100%" }}
                  readOnly={mode === DISPLAY_MODE.READ_ONLY}
                />
              }
            />
          </Form.Item>
        );
      },
    },
    {
      title: "Birim Fiyat",
      dataIndex: "unitPrice",
      editable: true,

      render: (text, record, index) => {
        return (
          <Form.Item
            style={{ margin: 0 }}
            hasFeedback={true}
            validateStatus={
              errors.hardwares && errors.hardwares[index]?.unitPrice && "error"
            }
          >
            <Controller
              control={form.control}
              name={`hardwares[${index}].unitPrice`}
              as={
                <InputNumber
                  style={{ width: "100%" }}
                  readOnly={mode === DISPLAY_MODE.READ_ONLY}
                />
              }
            />
          </Form.Item>
        );
      },
    },
    {
      title: "Para Birimi",
      dataIndex: "currency",
      editable: true,
      render: (text, record, index) => {
        return (
          <Form.Item
            style={{ margin: 0 }}
            hasFeedback={true}
            validateStatus={
              errors.hardwares && errors.hardwares[index]?.currency && "error"
            }
          >
            <Controller
              control={form.control}
              name={`hardwares[${index}].currency`}
              as={
                <Select
                  className={
                    mode === DISPLAY_MODE.READ_ONLY ? "readOnly" : null
                  }
                >
                  <Select.Option value="TURKISH_LIRA" key="TURKISH_LIRA">
                    ₺
                  </Select.Option>
                  <Select.Option value="US_DOLLAR" key="US_DOLLAR">
                    $
                  </Select.Option>
                  <Select.Option value="EURO" key="EURO">
                    €
                  </Select.Option>
                </Select>
              }
            />
          </Form.Item>
        );
      },
    },
    {
      title: "İşlemler",
      dataIndex: "operation",
      width: 100,
      fixed: "right",
      render: (text, record, index) => {
        return (
          <>
            {/* useArrayField yapılarında, itemdaki değişikliği gönderebilmek için hidden bir input
                alanında Id değerini tutmak ve formOnSubmitde bu idyi kullanarak nesneleri mergelemeliyiz*/}
            <Controller
              control={form.control}
              name={`hardwares[${index}].id`}
              as={<Input type="hidden" />}
            />
            <Popconfirm
              title="Emin Misin?"
              onConfirm={() => remove(index)}
              icon={<FontAwesomeIcon icon={["far", "trash-alt"]} />}
              okText="Kaldır"
              cancelText="Geri"
            >
              <Button type="danger" disabled={mode === DISPLAY_MODE.READ_ONLY}>
                <FontAwesomeIcon icon={["far", "trash-alt"]} />
              </Button>
            </Popconfirm>
          </>
        );
      },
    },
  ];

  return (
    <Table
      size="small"
      scroll={{ x: 300, y: 300 }}
      bordered
      rowKey={(row) => row.id}
      title={() => {
        return (
          <Button
            key="add"
            disabled={mode === DISPLAY_MODE.READ_ONLY}
            onClick={() => {
              append({});
            }}
          >
            <FontAwesomeIcon icon={["fas", "plus"]} />
          </Button>
        );
      }}
      dataSource={hardwares}
      columns={columns}
    />
  );
}
